import L from 'leaflet';
import RotateIcon from 'src/app/utils/RotateIcon';
import { formatDisplayName } from 'src/app/utils/vehicleDisplay';
import { getIconStatus } from 'src/app/utils/vehicleService';

export const DEFAULT_CENTER = [21.024683, 105.832495];

export const GRID_OPTIONS = [
  { label: '1x1', size: 1, columns: 1 },
  { label: '2x2', size: 4, columns: 2 },
  { label: '3x3', size: 9, columns: 3 },
  { label: '4x4', size: 16, columns: 4 },
  { label: '6x6', size: 36, columns: 6 },
  { label: '8x8', size: 64, columns: 8 }
];

export const CAMERA_DEVICE_TYPES = new Set(['VGPS_2CAM', 'VGPS_4CAM']);

export const getDeviceTypeName = vehicle =>
  vehicle?.device_type || vehicle?.vehicle?.device_type || vehicle?.vehicle_type || '';

export const getMaxCameraCount = vehicle =>
  getDeviceTypeName(vehicle) === 'VGPS_4CAM' ? 4 : 2;

export const getVehicleLabel = vehicle => {
  if (vehicle?.is_display_name && vehicle?.name?.trim()) {
    return formatDisplayName(vehicle.name, 28);
  }

  return vehicle?.license_plate || vehicle?.device_serial || '--';
};

export const getVehicleTimestamp = vehicle => {
  if (!vehicle?.created_at) return '--';

  const value = Number(vehicle.created_at);
  if (Number.isFinite(value) && value > 0) {
    const date = new Date(value * 1000);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month} ${hours}:${minutes}:${seconds}`;
  }

  return '--';
};

export const buildStreamKey = (vehicle, channel) =>
  `${vehicle.device_serial || vehicle.device_id}-${channel}`;

export const createVehicleIcon = vehicle => {
  try {
    if (!vehicle) {
      return L.icon({
        iconUrl: '/static/iconSvg/cars/car_lost_gsm.svg',
        iconAnchor: [16, 16],
        iconSize: [32, 32]
      });
    }

    if (vehicle?.debt === true) {
      return L.icon({
        iconUrl: '/static/iconSvg/motors/motor_expired.svg',
        iconAnchor: [16, 16],
        iconSize: [32, 32]
      });
    }

    const iconUrl =
      getIconStatus(vehicle?.device_status, vehicle?.vehicle_type) ||
      '/static/iconSvg/cars/car_lost_gsm.svg';
    let iconObject = RotateIcon.makeIcon(iconUrl);

    if (typeof iconObject.setRotation === 'function') {
      iconObject = iconObject.setRotation({
        deg: vehicle?.direction || 0.001
      });
    }

    const rotatedUrl =
      typeof iconObject.getUrl === 'function' ? iconObject.getUrl() : iconUrl;
    const validUrl = rotatedUrl?.startsWith('data:image') ? rotatedUrl : iconUrl;
    const iconSize =
      typeof iconObject.getSize === 'function' ? iconObject.getSize() : [32, 32];

    return L.icon({
      iconUrl: validUrl,
      iconAnchor: [iconSize[0] / 2, iconSize[1] / 2],
      iconSize
    });
  } catch (error) {
    return L.icon({
      iconUrl: '/static/iconSvg/cars/car_lost_gsm.svg',
      iconAnchor: [16, 16],
      iconSize: [32, 32]
    });
  }
};
